import settings from "../utils/settings";
import SFError from "../models/SfError";
const useAdjustTransaction = () => {
  const adjustTransaction = async ({
    transactionNo,
    pin,
    memberId,
    amount,
    remark,
    version,
  }) => {
    const { realmId, branchId, lang, token } = settings();
    try {
      const result = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/payment/adjust`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            locale: lang,
            transaction_no: transactionNo,
            type: "reward",
            authorize_pin: pin,
            member_id: memberId,
            realm_id: realmId,
            branch_id: branchId,
            amount: Number(amount),
            remark: remark,
            __v: version,
          }),
        }
      );

      const isOK = result.ok;
      const status = result.status;
      if (!isOK) {
        const jsonResult = await result.json();
        const error = new SFError({
          status: status,
          code: jsonResult.code,
          message: jsonResult.message,
        });

        return error.json();
      }
      const jsonResult = await result.json();
      return jsonResult;
    } catch (error) {
      const sfError = new SFError({ message: String(error) });
      return sfError.json();
    }
  };
  return { adjustTransaction };
};

export default useAdjustTransaction;
